import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './HomePage';
import BooksIndexPage from './BooksIndexPage';
import AuthorsIndexPage from './AuthorsIndexPage';
import AuthorBooksPage from './AuthorBooksPage';
import SupportPage from './SupportPage';
import PrivacyPage from './PrivacyPage';
import MansfieldianAppPage from './MansfieldianAppPage';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/books" element={<BooksIndexPage />} />
          <Route path="/authors" element={<AuthorsIndexPage />} />
          <Route path="/authors/:authorName" element={<AuthorBooksPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/mansfieldian-app" element={<MansfieldianAppPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
